module.exports = __webpack_public_path__ + "media/cottonwool.ae761939.wav";